var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowAscendingDescending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ascending",
    d: "M8.5 5C8.5 4.72386 8.27614 4.5 8 4.5C7.72386 4.5 7.5 4.72386 7.5 5H8.5ZM7.64645 18.3536C7.84171 18.5488 8.15829 18.5488 8.35355 18.3536L11.5355 15.1716C11.7308 14.9763 11.7308 14.6597 11.5355 14.4645C11.3403 14.2692 11.0237 14.2692 10.8284 14.4645L8 17.2929L5.17157 14.4645C4.97631 14.2692 4.65973 14.2692 4.46447 14.4645C4.2692 14.6597 4.2692 14.9763 4.46447 15.1716L7.64645 18.3536ZM7.5 5L7.5 18H8.5V5H7.5Z",
    fill: "#97A3B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Descending",
    d: "M15.5 18C15.5 18.2761 15.7239 18.5 16 18.5C16.2761 18.5 16.5 18.2761 16.5 18H15.5ZM16.3536 4.64645C16.1583 4.45118 15.8417 4.45118 15.6464 4.64645L12.4645 7.82843C12.2692 8.02369 12.2692 8.34027 12.4645 8.53553C12.6597 8.7308 12.9763 8.7308 13.1716 8.53553L16 5.70711L18.8284 8.53553C19.0237 8.7308 19.3403 8.7308 19.5355 8.53553C19.7308 8.34027 19.7308 8.02369 19.5355 7.82843L16.3536 4.64645ZM16.5 18V5H15.5V18H16.5Z",
    fill: "#97A3B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAscendingDescending);
export default __webpack_public_path__ + "static/media/arrow_ascending_descending.13eb9c634260451bb464d1499f0a674a.svg";
export { ForwardRef as ReactComponent };